export const COMPLETION_SHIMMER_DELAY_MS = 600;
export const COMPLETION_SHIMMER_DURATION_MS = 1200;
export const COMPLETION_SCROLL_IDLE_MS = 140;
export const COMPLETION_SCROLL_MAX_WAIT_MS = 1500;

export function getCompletionScrollBehavior(prefersReducedMotion) {
  return prefersReducedMotion ? 'auto' : 'smooth';
}

export function scheduleCompletionCelebration({
  target,
  onReady,
  minimumDelay = COMPLETION_SHIMMER_DELAY_MS,
  idleDelay = COMPLETION_SCROLL_IDLE_MS,
  maximumDelay = COMPLETION_SCROLL_MAX_WAIT_MS,
}) {
  let minimumElapsed = false;
  let scrollIdle = true;
  let finished = false;
  let idleTimer = null;

  const timers = new Set();
  const schedule = (callback, delay) => {
    const timer = setTimeout(() => {
      timers.delete(timer);
      callback();
    }, delay);
    timers.add(timer);
    return timer;
  };

  const cleanup = () => {
    if (finished) return;
    finished = true;
    target?.removeEventListener?.('scroll', onScroll);
    timers.forEach(timer => clearTimeout(timer));
    timers.clear();
  };

  const finish = () => {
    if (finished) return;
    cleanup();
    onReady();
  };

  const maybeFinish = () => {
    if (minimumElapsed && scrollIdle) finish();
  };

  const onScroll = () => {
    if (finished) return;
    scrollIdle = false;
    if (idleTimer !== null) {
      clearTimeout(idleTimer);
      timers.delete(idleTimer);
    }
    idleTimer = schedule(() => {
      idleTimer = null;
      scrollIdle = true;
      maybeFinish();
    }, idleDelay);
  };

  target?.addEventListener?.('scroll', onScroll, { passive: true });
  schedule(() => {
    minimumElapsed = true;
    maybeFinish();
  }, minimumDelay);
  schedule(finish, maximumDelay);

  return cleanup;
}

export function getCenteredActivityScrollTop({
  rect,
  pageYOffset,
  viewportHeight,
}) {
  if (!rect || !Number.isFinite(rect.top) || !Number.isFinite(rect.height)) {
    return Math.max(0, Number(pageYOffset) || 0);
  }
  const documentCenter = (Number(pageYOffset) || 0) + rect.top + (rect.height / 2);
  return Math.max(0, documentCenter - ((Number(viewportHeight) || 0) / 2));
}
